import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyIcon = _resolveComponent("CompanyIcon")!
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createBlock(_component_a_flex, {
    class: "content",
    justify: "space-between",
    align: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CompanyIcon, {
        class: "left",
        pattern: "color",
        size: "normal"
      }),
      _createVNode(_component_a_flex, {
        align: "center",
        class: "right"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.title, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["card", _ctx.newId == item.id ? 'card-new' : '']),
              onClick: ($event: any) => (_ctx.gotoPage(item.name))
            }, _toDisplayString(item.title), 11, _hoisted_1))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}